export default function() {
    const self = this

    self.loadSymplaEvents()
}
